import apiClient from '../index';

export const remindPledgeApi = {
  // Get pledge reminder guest list for notification reminders
  getReminderList: () => apiClient.get('/pledges/reminder-list'),

  // Send pledge reminders
  sendReminder: (data) => apiClient.post('/pledges/send-reminder', data),
};

export default remindPledgeApi;
